import {CustomAddresses} from '../actions/index';
import {Address, Region, StateUtils, USER_ADDRESSES} from '@spartacus/core';
import {ActionReducerMap} from '@ngrx/store';
import {InjectionToken} from '@angular/core';
import {AddressState} from '../selectors/user-addresses.selectors';

export const initialState: AddressState = {
  entities: [],
  zone: null
};

export function reducer(
  state = initialState,
  action: CustomAddresses.CustomUserAddressesAction
): AddressState {
  switch (action.type) {
    case CustomAddresses.LOAD_USER_ADDRESSES_FAIL: {
      return initialState;
    }

    case CustomAddresses.LOAD_USER_ADDRESSES_SUCCESS: {
      const entities: Address[] = action.payload.addresses;
      const zone: string = action.payload.zone;
      if (entities || zone) {
        return {
          ...state,
          entities,
          zone,
        };
      }
      return initialState;
    }
  }
  return state;
}


export const USER_ADDRESS_ZONE = 'user-address-zone';

export interface StateWithUserAddressState {
  [USER_ADDRESS_ZONE]: UserAddressState;
}

export interface UserAddressState{
  addressesZone: StateUtils.LoaderState<AddressState>;
}

export function getReducers(): ActionReducerMap<UserAddressState> {
  return {
    addressesZone: StateUtils.loaderReducer<AddressState>(USER_ADDRESSES, reducer),
  };
}

export const reducerAddressesByZoneToken: InjectionToken<ActionReducerMap<StateWithUserAddressState>> =
  new InjectionToken<ActionReducerMap<UserAddressState>>('AddressesByZoneReducer');

export const reducerAddressesByZoneProvider = {
  provide: reducerAddressesByZoneToken,
  useFactory: getReducers,
};

